import gsap from 'gsap';

export default {
  init() {
    // JavaScript to be fired on all pages

  },
  finalize() {
    /* eslint-disable */
    const loader = document.querySelector('.loader');
    let blocks = loader.querySelectorAll('.block');

    window.addEventListener('load', () => {

      // let promise = new Promise( (resolve, reject) => {
      //   if (loader_animate(blocks)) {
      //     resolve();
      //   } else {
      //     reject(console.log(Error + 'Rejected'));
      //   }
      // });
      // promise
      //   .then(val => translate_sliders())
      //   .then(val => setTimeout(() => {hero_reveal_squares() }, 1000))
      //   .then(val => move_content_on_scroll())
      //   .catch(err => console.log(err));

      setTimeout( () => {
        if (body.classList.contains('test-page')) {
          loader_animate(blocks);
          translate_sliders();
          move_content_on_scroll();
          setTimeout(() => {hero_reveal_squares() }, 1050)
        }
      })
    });
    /* eslint-enable */

    if (document.body.classList.contains('home')) {
      // setTimeout(() => { smoothScroll() }, 1600);
      setTimeout(() => { smoothScroll() }, 950);
    } else {
      // setTimeout(() => { smoothScroll() }, 1600);
      setTimeout(() => { smoothScroll() }, 1000);
    }
    // old timeout 545 525 325);

    /*
      loader_animate
      - Inital loader for site content
    */
    function loader_animate(element) {
      loader.style.opacity = 1;

      /* eslint-disable */
      gsap.to(element, {
        duration: 1,
        scale: 0,
        y: 200,
        ease: "power1.inOut",
        stagger: {
          grid: "auto",
          ease: "power1.inOut",
          // from: "center",
          from: "left",
          amount: 0.75,
        },
      });
      /* eslint-enable */
      return true;
    }

    /*
      change_page_loader
      - When links are clicked in the site and the loader is brought in
    */
    // function change_page_loader(element) {
    //   /* eslint-disable */
    //   gsap.to(element, {
    //     duration: 1,
    //     scale: 1,
    //     y: 0,
    //     ease: "power1.inOut",
    //     stagger: {
    //       grid: "auto",
    //       ease: "power1.inOut",
    //       // from: "center",
    //       from: "left",
    //       amount: -0.75,
    //     },
    //   });
    //   /* eslint-enable */
    // }

    // Javascript classes that the loader will let happen
    let js_links = ['prevent-loader'];

    function check_for_js_links(event) {
      event.preventDefault();

      for (let a = 0; a < js_links.length; a++) {
        if (event.target.classList.contains(js_links[a])) {
          return true;
        }
      }
    }

    // Checks if event for anchor or at least the first and second parent element
    function check_if_anchor_or_child_of_anchor(event) {
      if (event.target.tagName == "A") {
        return 1;
      }
      if(event.target.parentElement.tagName =="A") {
        return 2;
      }
      if (event.target.parentElement.parentElement.tagName == "A") {
        return 3;
      }
    }

    /*
      link_to_destination
      - If the loader is needed to swap pages it get the link attributes.
      - brings in the loader
      - Goes to the proper link
    */
    function link_to_destination(event) {
      let next = event.target;
      let target = event.target;

      if (check_if_anchor_or_child_of_anchor(event) == 2) {
        next = event.target.parentElement.href;
        target = event.target.parentElement.getAttribute('target');
      } else if (check_if_anchor_or_child_of_anchor(event) == 3) {
        next = event.target.parentElement.parentElement.href;
        target = event.target.parentElement.parentElement.getAttribute('target');
      } else {
        next = event.target.href;
        target = event.target.getAttribute('target');
      }

      // If an inline anchor
       if (next.indexOf('mailto:') != -1 || next.indexOf('tel:') != -1 ) {
        window.open(next);
      }
      else if (next.indexOf('#') != -1) {
        event.preventDefault();
      }
      else {
        // Brings in the loader and changes the location
        if (target == '_blank') {
          // setTimeout( () => { window.open(next);  }, 1600);
          window.open(next);
        } else if (target == null) {
          // change_page_loader(blocks);
          // setTimeout( () => { window.location = next; }, 1600);
          window.location = next;
        } else {
          event.preventDefault();
          // change_page_loader(blocks);
          // setTimeout( () => { window.location = next; }, 1600);
          window.location = next;
        }
      }
    }

    /*
      General Click
      1. It sees if an anchor is clicked
      2. If it isn't a JS class it
        - stops the default
        - brings down the loader
      3. If it one of the JS classes it lets it continue

      - mouseup and mousedown check to see if the user "dragged" their mouse.
      If so preventDefault
    */

    /* eslint-disable */
    let mouseup_mouseX = 0;
    let mouseup_mouseY = 0;
    let mousedown_mouseX = 0;
    let mousedown_mouseY = 0;
    /* eslint-enable */

    document.addEventListener('mouseup', event => {
      mouseup_mouseX = event.clientX;
      mouseup_mouseY = event.clientY;
    })
    document.addEventListener('mousedown', event => {
      mousedown_mouseX = event.clientX;
      mousedown_mouseY = event.clientY;
    })

    document.addEventListener('click', (event) => {
      if (mousedown_mouseX > mouseup_mouseX) {
        event.preventDefault();
      }
      else if (event.target.parentElement.parentElement.id == 'mobile_menu') {
        event.preventDefault();
        let reverse_nav_li = reverse_array_order(document.querySelectorAll('#mobile-nav nav li'), reverse_nav_li);

        /* eslint-disable */
        var close_nav_item = gsap.timeline();
        close_nav_item.to(document.querySelector('header .mobile-social'), { ease: "power0.inOut", duration: 0.02, delay: 0, x: -50, y: 0, opacity: 0 });
        close_nav_item.to(reverse_nav_li, { ease: "power0.inOut", duration: 0.02, delay: 0.01, x: -50, y: 0, opacity: 0, stagger: { amount: 0.6, grid: "auto", from: "bottom" }});

        /* eslint-enable */
        setTimeout(() => {
          document.querySelector('header .bws-logo').classList.add('fade-out-item');
          document.querySelector('header .navigation-trigger').classList.add('fade-out-item');
          document.querySelector('header').classList.add('fade-out-item');
        }, 600);

        setTimeout(() => {
          window.location = event.target.href;
        }, 800)
      } else {
        if (check_if_anchor_or_child_of_anchor(event)) {
          if (check_for_js_links(event)) {
            event.preventDefault();
          } else {
            event.preventDefault();
            link_to_destination(event);
            scrollToItem(event);
          }
        }
      }
    });

  /*
    FollowNavLine
    1. Animates line to the current nav item
    2. On Mounse enter/leave changes the position and width of the nav line
  */
  function followNavLine() {
    let line = document.getElementById('nav-line');
    let navItems = document.querySelectorAll('.desktop-main-nav a');
    let currentPathname = window.location.pathname;
    let header = document.querySelector('header');

    function setLine() {

      let path;

      // If URL has pathname
      if (currentPathname.indexOf('/', 0) == 0 ) {
        path = currentPathname.split('/');

        if (path[1] == 'project-channel') {
          navItems[3].parentElement.classList.add('has-line');
        }

        if (path[1] == 'service') {
          navItems[2].parentElement.classList.add('has-line');
        }

        if (path[1] == 'careers-listing' || path[1] == 'careers-form') {
          navItems[5].parentElement.classList.add('has-line');
        }

        if (body.classList.contains('single-post')) {
          navItems[4].parentElement.classList.add('has-line');
      }
    }

    // Adds active line class too level one nav
    for (let a = 0; a < navItems.length; a++) {

      if (navItems[a].getAttribute('aria-current')) {
        if (navItems[a].innerHTML != 'Contact Us')
          navItems[a].parentElement.classList.add('has-line')
        }
      }

      // Adds active line to projects class
      if (path[1] == 'project' || path[1] == 'projects') {
        navItems[3].parentElement.classList.add('has-line');
      }

      let currentItem = document.querySelectorAll('.has-line');

      // Animate Line
      function moveLine(item_x, item_width, item_opacity) {
        /* eslint-disable */
        gsap.to(line, {ease: "power0.inOut", delay: 0, y: 0, top: 0, x: item_x, width: item_width, duration: 0.4, opacity: item_opacity});
        /* eslint-enable */
      }

      // If is nav page or not
      if (currentItem.length == 0) {
          moveLine(navItems[0].getBoundingClientRect().x, navItems[0].offsetWidth, 0);
      } else {
        setTimeout(function() {
          moveLine(currentItem[0].childNodes[0].getBoundingClientRect().x, currentItem[0].childNodes[0].offsetWidth, 1);
        }, 1400);
      }

      let navLi = document.querySelectorAll('.desktop-main-nav li');

      function followLine() {
        // on mouseenter line follows mouse
        navLi.forEach( function(item) {
          item.addEventListener('mouseenter', function(e) {
            if (item.childNodes[0].innerHTML.toLowerCase() == 'contact us') {
              moveLine(e.target.childNodes[0].getBoundingClientRect().x, e.target.childNodes[0].offsetWidth, 0);

            } else {
              moveLine(e.target.childNodes[0].getBoundingClientRect().x, e.target.childNodes[0].offsetWidth, 1);
            }
          });
        });
      }

      // Reset nav line to current page link on mouseleave
      function resetLine() {
        if (currentItem.length == 0) {
          header.addEventListener('mouseleave', function() {
            moveLine(0,0, 1);
          });
        }
        else if (currentItem.length !== 0) {
          header.addEventListener('mouseleave', function() {
            moveLine(currentItem[0].childNodes[0].getBoundingClientRect().x, currentItem[0].childNodes[0].offsetWidth, 1);
        });
      }
    }

    followLine();
    resetLine();
    }
    setLine();
  }

  let body = document.querySelector('body');
  let smooth_js_scroll;

  /* eslint-disable */
  /*
    smoothScroll
    1. Removes native scroll
    2. Translates the main div content
  */
  function smoothScroll() {
    if(!isMobile()) {

      const content = document.querySelector('.content');
      const smooth = new Smooth({
        native: false,
        section: content,
        ease: 0.1,
        noscrollbar: true,
      });

      smooth.vs.options.mouseMultiplier = 0.4;
      smooth.init();
      body.classList.add('smooth');
      document.querySelector('main').classList.add('smooth');

      smooth_js_scroll = smooth;
    }
  }
  /* eslint-enable */

  /*
    sliderPagerDataCount
    - Uses the lightSlider pager to contorl the custom arrows
  */
  function sliderPagerDataCount(rowId) {
  let pager = document.querySelectorAll(rowId + ' .lSPager li');

    pager.forEach ( function(page) {
      page.setAttribute('data-count', page + 1);
    });
  }

  /*
    light_slider_controls
    - Controls custom lightSlider arrows
    - Moving slider in either direction
    - If no more slides are present it disables the arrow
  */
  function light_slider_controls(sliderVar, sliderId) {
    let next = document.querySelector(sliderId + ' .next');
    let prev = document.querySelector(sliderId + ' .prev');
    let sliderRow = document.querySelector(sliderId + ' .slider-wrapper');

    if (next) {
      next.addEventListener('click', function(e) {
        e.preventDefault();
        sliderVar.goToNextSlide();
      });
    }

    if (prev) {
      prev.addEventListener('click', function(e) {
        e.preventDefault();
        sliderVar.goToPrevSlide();
      });
    }

    sliderPagerDataCount(sliderId);

    if (sliderRow) {
      sliderRow.addEventListener('click', function() {
        let activeSlide = document.querySelectorAll(sliderId + ' .lSPager li');

        if (activeSlide[activeSlide.length - 1].classList == 'active' ) {
          prev.classList.remove('disabled');
          next.classList.add('disabled');
        }
        if (activeSlide[0].classList == '' && activeSlide[activeSlide.length - 1].classList == '') {
          prev.classList.remove('disabled');
          next.classList.remove('disabled');
        }
        if (activeSlide[0].classList == 'active') {
          prev.classList.add('disabled');
          next.classList.remove('disabled');
        }
      });
    }
  }

  var pageInit = {
  /* eslint-disable */
  /*
    map_init
    - creates the google maps (style, map pin, position of pins)
  */
  map_init: function(mapId, pinlat, pinlong, lat, long, contentNumber) {

    var map = new google.maps.Map(document.getElementById(mapId), {
      zoom: 15,
      center: {lat: lat, lng: long},
      zoomControl: false,
      mapTypeControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      styles: [
        {
          "featureType": "landscape.man_made",
          "stylers": [
            {
              "color": "#ffffff",
            }
          ]
        },
        {
          "featureType": "landscape.man_made",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#e0e0e0",
            }
          ]
        },
        {
          "featureType": "landscape.natural",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#b4e67f",
            }
          ]
        },
        {
          "featureType": "landscape.natural.landcover",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#b4e67f",
            },
            {
              "saturation": 100,
            },
            {
              "lightness": 20,
            },
            {
              "weight": 1.5,
            }
          ]
        },
        {
          "featureType": "landscape.natural.terrain",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#b4e67f",
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#ffffff",
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#78bced",
            }
          ]
        }
      ],
    });

    var map_pin = {
      path: "M1.5,1.3c0.8-0.8,1.8-1.2,3-1.2s2.1,0.4,3,1.2C8.3,2,8.7,3,8.7,4.2c0,0.6-0.1,1.3-0.4,2C8,6.9,7.6,7.6,7.2,8.3 C6.8,8.9,6.3,9.5,6,10.1c-0.4,0.6-0.8,1-1.1,1.3l-0.4,0.5c-0.1-0.1-0.3-0.3-0.4-0.5c-0.2-0.2-0.5-0.6-1-1.3C2.6,9.5,2.2,8.9,1.8,8.3 c-0.4-0.6-0.7-1.3-1-2s-0.5-1.5-0.5-2C0.3,3.1,0.8,2.1,1.5,1.3z M3.4,5.3c0.3,0.3,0.6,0.4,1.1,0.4c0.4,0,0.8-0.1,1.1-0.4 C5.8,5,6,4.7,6,4.2S5.8,3.5,5.6,3.2C5.3,2.9,4.9,2.8,4.5,2.8c-0.4,0-0.8,0.1-1.1,0.4S3,3.8,3,4.2S3.2,5,3.4,5.3z",
      fillColor: '#f27442',
      fillOpacity: 1,
      strokeColor: '#f27442',
      strokeWeight: 0,
      anchor: new google.maps.Point(pinlat, pinlong),
      scale: 3,
    }

    var map_content = [
      '<div class="mapcontent"><p class="large">45 Third Street Suite C Phillipsburg, NJ 08865, United States</h1><div id="bodyContent"><p class="small"><a href="https://www.google.com/maps/place/45+3rd+St+Suite+C,+Phillipsburg,+NJ+08865/data=!4m2!3m1!1s0x89c46db374088035:0xe4017c6399932593?sa=X&ved=2ahUKEwiB_L_P5tjlAhXPmeAKHeguCxQQ8gEwAHoECAoQAQ" target="_blank" class="underlined-inline"><span>Directions</span></a></p></div></div>',
      '<div class="mapcontent"><p class="large">642 Newtown-Yardley Road Suite 300 Newtown, PA 18940,United States</h1><div id="bodyContent"><p class="small"><a href="https://www.google.com/maps/place/642+Newtown+Yardley+Rd+%23300,+Newtown,+PA+18940/@40.2277788,-74.9231572,17z/data=!3m1!4b1!4m5!3m4!1s0x89c1548aaa5d2ac3:0x9b041c0188bba048!8m2!3d40.2277788!4d-74.9209685" target="_blank" class="underlined-inline"><span>Directions</span></a></p></div></div>',
      '<div class="mapcontent"><p class="large">3425 Simpson Ferry Road Suite 203 Camp Hill, PA  17011, United States</h1><div id="bodyContent"><p class="small"><a href="https://www.google.com/maps/place/3425+Simpson+Ferry+Rd+%23203,+Camp+Hill,+PA+17011/data=!4m2!3m1!1s0x89c8c20d8ddab135:0x5cdc7deed5535fc5?sa=X&ved=2ahUKEwiCgN606djlAhWBd98KHQRrAjoQ8gEwAHoECAoQAQ" target="_blank" class="underlined-inline"><span>Directions</span></a></p></div></div>',
      '<div class="mapcontent"><p class="large">200 Charles Ewing Blvd. Suite 140, Ewing, New Jersey 08628, United States</h1><div id="bodyContent"><p class="small"><a href="https://www.google.com/maps/place/200+Charles+Ewing+Blvd+%23140,+Ewing+Township,+NJ+08628/@40.2876702,-74.7939541,17z/data=!3m1!4b1!4m5!3m4!1s0x89c3fd48e9c6f549:0x9a5b1bcc2706662b!8m2!3d40.2876661!4d-74.7917654" target="_blank" class="underlined-inline"><span>Directions</span></a></p></div></div>',
    ];

    var infowindow = new google.maps.InfoWindow({
      content: map_content[contentNumber]
    });

    var marker = new google.maps.Marker({
      position: {lat: lat, lng: long},
      map: map,
      icon: map_pin,
      animation: google.maps.Animation.DROP,
      title: 'Uluru (Ayers Rock)',
    });

    marker.addListener('click', function() {
       infowindow.open(map, marker);
     });

    function toggleBounce() {
        if (marker.getAnimation() !== null) {
          marker.setAnimation(null);
        } else {
          marker.setAnimation(google.maps.Animation.BOUNCE);
        }
      }
  },
  /* eslint-enable */

  // Prevents Default hash anchor behavior
  // reset_anchor_scroll: function() {
  //   window.addEventListener('DOMContentLoaded', function() {

  //     if (window.location.hash != null) {
  //       window.addEventListener('scroll', function() {
  //         window.scroll(0, 0);
  //       });
  //     }
  //   });
  // },
}

  /* eslint-disable */
  function reverse_array_order(array_variable, new_output_arr) {
    let arr = array_variable;
    let new_arr = new Array;

    for (let a = arr.length; a >= 0; a--) {
      new_arr.push(arr[a]);
    }
    new_output_arr = new_arr;

    if (new_output_arr[0] == undefined) {
      new_output_arr.shift();
      return new_output_arr;
    } else {
      return new_output_arr;
    }
  }
  /* eslint-enable */

  let trigger = document.querySelector('.navigation-trigger');
  let mobile_nav = document.getElementById('mobile-nav');
  let header = document.getElementById('bws-header');
  let nav_li = document.querySelectorAll('#mobile-nav nav li');
  let nav_social = document.querySelector('header .mobile-social');
  let reverse_nav_li = '';
  // let nav_blocks = document.querySelectorAll('.mobile-navigation .nav-loader .block');

  trigger.addEventListener('click', mobile_nav_active);

  function mobile_nav_active() {
    event.preventDefault();

    if ( ! trigger.classList.contains('active') ) {
      trigger.classList.remove('reset');
      trigger.classList.add('active');
      mobile_nav.classList.add('active');
      mobile_nav.style.animation = 'menuIn 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards';
      header.classList.add('active');
      body.classList.add('no-orflow');
      /* eslint-disable */


      var open_nav_item = gsap.timeline();
      open_nav_item.to(nav_li, {ease: "power0.inOut", duration: 0.02, delay: 0, x: 0, y: 0, opacity: 1, stagger: { amount: 0.6, grid: "auto", from: "left" }});
      open_nav_item.to(nav_social, { ease: "power0.inOut", duration: 0.02, delay: 0, x: 0, y: 0, opacity: 1 });
      /* eslint-enable */

    } else if ( trigger.classList.contains('active') ) {
      reverse_nav_li = reverse_array_order(nav_li, reverse_nav_li);

      /* eslint-disable */

      var close_nav_item = gsap.timeline();
      close_nav_item.to(nav_social, { ease: "power0.inOut", duration: 0.02, delay: 0, x: -50, y: 0, opacity: 0 });
      close_nav_item.to(reverse_nav_li, { ease: "power0.inOut", duration: 0.02, delay: 0.01, x: -50, y: 0, opacity: 0, stagger: { amount: 0.6, grid: "auto", from: "bottom" }});
      /* eslint-enable */

      setTimeout(() => {
        trigger.classList.remove('active');
        trigger.classList.add('reset');
        mobile_nav.classList.remove('active');
        mobile_nav.style.animation = 'menuOut 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards';
        header.classList.remove('active');
        body.classList.remove('no-overflow');
      // }, 2100);
      }, 1000);
    }
  }

  /*
    Form Validation
    - Sucess and failed events
  */

  // On mail failed
  document.addEventListener( 'wpcf7mailfailed', function(event) {
      cf7_form_failed(event);
  }, false );

  // On mail sent
  document.addEventListener( 'wpcf7submit', function(event) {
    // If there are form errors - don't submit
    if (event.detail.status == "validation_failed") {
      return;
    } else {
      cf7_form_success(event);
    }
  }, false );

  function cf7_form_success() {
    let response_wrapper = event.target.querySelector('.form-repsonse ');
    let success = event.target.querySelector('.form-repsonse .success');

    event.target.querySelector('.form-inner-wrapper').classList.add('done');

    /* eslint-disable */
    gsap.to('#' + response_wrapper.id, {ease: "power0.inOut", delay: 0, height: success.getBoundingClientRect().height, duration: 0.1});
    gsap.to(success.childNodes[1], 1, {ease: "power0.inOut", delay: 0.5, opacity: 1, duration: 0.4});
    gsap.to(success, 1, {ease: "power0.inOut", delay: 0.5, opacity: 1, duration: 0.4});
    gsap.to(success.parentElement, 1, {y: 0, delay: 1, ease: "power0.inOut", duration: 0.4});
    /* eslint-enable */
  }

  function cf7_form_failed() {
    let response_wrapper = event.target.querySelector('.form-repsonse ');
    let failed = event.target.querySelector('.form-repsonse .failed');

    event.target.querySelector('.form-inner-wrapper').classList.add('done');

    /* eslint-disable */
    gsap.to('#' + response_wrapper.id, {ease: "power0.inOut", delay: 0, height: (failed.getBoundingClientRect().height * 2), duration: 0.1});
    gsap.to(failed.childNodes[1], 1, {ease: "power0.inOut", delay: 0.5, opacity: 1, duration: 0.4});
    gsap.to(failed, 1, {ease: "power0.inOut", delay: 0.5, opacity: 1, duration: 0.4});
    gsap.to(failed.parentElement, 1, {y: 0, delay: 1, ease: "power0.inOut", duration: 0.4});
    /* eslint-enable */
  }

  if (document.querySelector('.wpcf7') != null || document.querySelector('.wpcf7') != undefined) {
    // Prevents textarea space bar scroll down jump
    document.addEventListener('keydown', (event) => {
      if( ! isMobile() ) {
        if (event.keyCode == 32) {
          smooth_js_scroll.off();
          setTimeout( ()=> {
            smooth_js_scroll.on();
          }, 200);
        }
      }
    })
  }

  // Form page reload
  if (document.querySelector('p.reload') != null) {
    let form_reload = document.querySelector('p.reload');
    form_reload.addEventListener('click', reload_page);
  }

  function reload_page() {
    location.reload();
  }

  // File Upload
  let file = document.querySelectorAll('.file-wrapper input[type="file"]');

   file.forEach( function(files) {
     files.addEventListener('change', () => {

       let fileName = files.value;
       let updatedFileName = fileName.split('\\');
       let text = files.parentElement.parentElement.querySelector('.text');

       if (fileName == '') {
         text.innerHTML = 'Select File';
         files.classList.remove('active');
       } else {
        text.innerHTML = updatedFileName[updatedFileName.length - 1];
        files.classList.add('active');
       }
     });
   });


  // Team Posts
  let teamLi = document.querySelectorAll('.team-list li .absolute-link');
  let home_team = document.querySelectorAll('.post-lists .team-home-link');
  let close = document.querySelectorAll('.team-list .close-item');
  let home_team_close = document.querySelectorAll('.post-lists .team-copy a.close-item');

  // Open team li
  function open_team_item(var_name) {
    var_name.forEach( team => {
      team.addEventListener('click', function(event) {
        event.preventDefault();

        // Display the bio - if it dosen't have the active class make it active
        if (event.target.tagName === "A" && event.target.classList.contains('absolute-link')) {
          if (! team.classList.contains('active-team')) {
            team.parentElement.classList.add('active-team');

            if( ! isMobile() ) {
              smooth_js_scroll.off();
            }
          }
        }
      });
    });
  }

  open_team_item(teamLi); // About
  open_team_item(home_team); // Home mixed post list

  // Close the bio
  function close_team_item(var_name) {
    var_name.forEach ( close_item => {
      close_item.addEventListener('click', function(event) {
        event.preventDefault();

        // find the parent li and remove the active class
        if (event.target.classList.contains('close-item') && event.target.tagName == "A") {
          close_item.parentElement.parentElement.classList.remove('active-team');

          if( ! isMobile() ) {
            smooth_js_scroll.on();
          }
        }
      });
    });
  }

  close_team_item(close); // About
  close_team_item(home_team_close); // Home mixed post list


  // Read More Accordion
  let read_more_triggers = document.querySelectorAll('.read-more-trigger');

  read_more_triggers.forEach ( read_more =>   {
    read_more.addEventListener('click', read_more_expand_and_close);
  });

  function read_more_expand_and_close() {
    let current_accordion;
    let content_height;
    let temp_height;

    event.preventDefault();

    current_accordion = this.id;

    if (event.target.tagName == "A" && event.target.classList.contains('read-more-trigger')) {
      current_accordion = this.id;
    }

    content_height = this.nextElementSibling;
    current_accordion = this;

    // Get the height of the current accordion inner child and add 40 for spacing
    temp_height = content_height.childNodes[1].clientHeight;
    temp_height = temp_height + 40;

    // If not active - increase the content height and add active classes
    if (! content_height.classList.contains('active')) {
      /* eslint-disable */
      gsap.fromTo(content_height, {height: 0}, {ease: "power0.inOut", delay: 0, height: temp_height, duration: 0.4});
      /* eslint-enable */

      content_height.classList.add('active');
      current_accordion.classList.add('active');
      current_accordion.childNodes[1].classList.add('change');

    } else {
      /* eslint-disable */
      gsap.fromTo(content_height, {height: content_height}, {ease: "power0.inOut", delay: 0, height: 0, duration: 0.4});
      /* eslint-enable */

      content_height.classList.remove('active');
      current_accordion.classList.remove('active');
      current_accordion.childNodes[1].classList.remove('change');
    }
  }

  function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }


  // Set pagination data-text
  function paginationData() {
    let items = document.querySelectorAll('.product-pagination .pagination .page-numbers');

    for(let a = 0; a < items.length; a++) {
      let text = items[a].innerHTML;
      items[a].setAttribute('data-text', text);
    }
  }

  servicesSidebarActive();
  paginationData();

  /*
    ScrollToItem
    1. If not mobile use smooth scroll js
    2. If mobile use gsap
  */
  if (document.querySelectorAll('.content a[href*="#"]').length >= 2) {
    let anchor = document.querySelectorAll('.content a[href*="#"]');

    Array.prototype.forEach.call(anchor, link => {
      link.addEventListener('click', scrollToItem);
    });
  } else if (document.querySelector('.content a[href*="#"]') != null) {
    let anchor = document.querySelector('.content a[href^="#"]');
    anchor.addEventListener('click', scrollToItem);
  }

  function scrollToItem(event) {
    event.preventDefault();

    let current_hash;
    let distance;

    if (check_if_anchor_or_child_of_anchor(event) == 2) {
      current_hash = event.target.parentElement.href;

    } else if (check_if_anchor_or_child_of_anchor(event) == 3) {
      current_hash = event.target.parentElement.parentElement.href;

    } else if (check_if_anchor_or_child_of_anchor(event) == 1) {
      current_hash = event.target.href;
    } else {
      current_hash = this.href;
    }

    current_hash = current_hash.split('/');
    current_hash = current_hash[current_hash.length - 1];
    current_hash = current_hash.substring(1, current_hash.length);

    if (current_hash != null) {
        setTimeout(function() {
          if ( ! isMobile() ) {
            distance = ( parseInt(document.getElementById(current_hash).offsetTop) - parseInt(document.getElementById(current_hash).clientHeight / 8) - document.getElementById('bws-header').clientHeight) - 15;
            smooth_js_scroll.scrollTo(distance);
          }
        }, 250);
    } else {
      if ( isMobile() ) {
        distance = parseInt(document.getElementById(current_hash).offsetTop) - parseInt(document.getElementById(current_hash).clientHeight / 8);
      }

      setTimeout(function() {
        /* eslint-disable */
        gsap.to(window, {duration: 2, scrollTo: distance});
        /* eslint-enable */
      }, 1000);
    }
  }

  if (body.classList.contains('contact-us')) {
    setTimeout(function() {
      pageInit.map_init('map-location-one', 0, 0, 40.6969694, -75.2008509, 0);
      pageInit.map_init('map-location-two', 0, 0, 40.2277788, -74.9231572, 1);
      pageInit.map_init('map-location-three', 0, 0, 40.2260676, -76.9394423, 2);
      pageInit.map_init('map-location-four', 0, 0, 40.288922, -74.790096, 3);
    }, 1000);
  }

  // Sticky Nav
  function make_it_stiky() {
    let header = document.querySelector('header.bws-header');
    let contentWrap = document.querySelector('.content').getBoundingClientRect().top;

    requestAnimationFrame(make_it_stiky);
    // requestAnimationFrame(mouse_element);

    if (contentWrap <= -100) {
      header.classList.add('sticky');
    } else if (contentWrap >= -90) {
      header.classList.remove('sticky');
    }
  }

  window.addEventListener('DOMContentLoaded', () => {
    followNavLine();
    make_it_stiky();
  });


  /* eslint-disable */
  // setTimeout( () => {
  //   parallax_images();
  // }, 800);

  /*
    translate_sliders
    - when the sliders come into the viewport translate to 0
  */
  function translate_sliders() {
    window.requestAnimationFrame(translate_sliders);
    let slider_row = document.querySelectorAll('.test-page section');
    const topViewport = window.pageYOffset;
    const midViewport = topViewport + (window.innerHeight / 1.2);

    Array.prototype.forEach.call(slider_row, item => {
        let inner_items = item.querySelectorAll('.lSSlideWrapper');
        let top = item.getBoundingClientRect().top - 45;
        let middle = top + (item.offsetHeight / 4);

        Array.prototype.forEach.call(inner_items, items => {
          const distance = (midViewport - middle) * 1.75;

          if ((distance * 1000) > middle) {
            /* eslint-disable */
            gsap.to(items, {duration: 0.8, ease: "power0.inOut", x: 0});
            /* eslint-enable */
          }
        });
    });
  }

  /* eslint-disable */
  /*
    hero_reveal_squares
    - animated heros blocks in
  */
  function hero_reveal_squares() {
    let hero_row = document.querySelectorAll('.test-page section.large-image-row .block');

    if (hero_row.length > 0) {
      /* eslint-disable */
      gsap.to(hero_row, {
        duration: 0.3,
        // delay: 0.1,
        delay: 0.01,
        opacity: function(index, target) {
          return target.dataset.opacity;
        },
        ease: "power0.inOut",
        stagger: {
          each: 0.1,
          grid: [1,6],
        }
      });
      /* eslint-enable */
    }
  }
  /* eslint-enable */

  /*
    parallax_images
    - Checks all sections for parallax elements
    - Then transform them based on the content wrapper transform
  */
  // function parallax_images() {

  //   const topViewport = window.pageYOffset;
  //   const midViewport = topViewport + ( window.innerHeight / 2);
  //   let sections = document.querySelectorAll('section');
  //   window.requestAnimationFrame(parallax_images);
  //   let parallax_section = [];
  //   let contentWrap = document.querySelector('.content').getBoundingClientRect().top;

  //   // Removes rows without parallax elements
  //   for (let c = 0; c < sections.length; c++) {
  //     if (sections[c].querySelectorAll('[data-parallax]').length > 0 ) {
  //       parallax_section.push(sections[c]);
  //     }
  //   }

  //   // Sets Values
  //   for (let a = 0; a < parallax_section.length; a++) {
  //     const topSection = parallax_section[a].offsetTop;
  //     const midSection = topSection + (parallax_section[a].offsetTop / 2);
  //     const distance_to_section = (contentWrap - (topSection - midSection) - topViewport);
  //     const parallax_tags = parallax_section[a].querySelectorAll('[data-parallax]');

  //     // Mves elements
  //     for (let b = 0; b < parallax_tags.length; b++) {
  //       const speed = parallax_tags[b].getAttribute('data-parallax');
  //       parallax_tags[b].style.transform = `translate(0, ${ distance_to_section * speed }px)`;
  //     }
  //   }
  // }

  /* eslint-disable */
  function move_content_on_scroll() {

    const topViewport = window.pageYOffset;
    const midViewport = topViewport + ( window.innerHeight / 2);
    let sections = document.querySelectorAll('section');
    window.requestAnimationFrame(move_content_on_scroll);
    let parallax_section = [];
    let contentWrap = document.querySelector('.content').getBoundingClientRect().top;

    // Removes rows without parallax elements
    for (let c = 0; c < sections.length; c++) {
      if (sections[c].querySelectorAll('[data-animate]').length > 0 ) {
        parallax_section.push(sections[c]);
      }
    }
    // Sets Values
    for (let a = 0; a < parallax_section.length; a++) {
      const topSection = parallax_section[a].offsetTop;
      const midSection = topSection + (parallax_section[a].offsetTop / 1.4);
      const parallax_tags = parallax_section[a].querySelectorAll('[data-animate]');

      if (contentWrap < (topSection - midSection) ) {
        // Moves elements
        for (let b = 0; b < parallax_tags.length; b++) {
          const transformY = parallax_tags[b].getAttribute('data-animate');
          parallax_tags[b].style.transform = `translate(0, ${ transformY }px)`;
        }
      }
    }
  }

  /* eslint-enable */

  function edit_slider_width(element) {
    setTimeout(function() {
      element.refresh();
    }, 500);
  }

  // Refresh the Slider on load to get the correct widths, heights, etc
  function servicesSidebarActive() {
    let currentUrl = window.location.pathname.split('/')[2];

    $('.services-menu a').each(function() {
      let thisHref = this.attributes[0].nodeValue.split('/')[4];

      if (thisHref == currentUrl) {
       this.parentElement.classList.add('current-menu-item');
      }
    });
  }

  $(document).ready(function() {
    if ($('#home-project-slider').length) {
      var home_project_slider = $('#home-project-slider').lightSlider({
        item: 3,
        autoWidth: false,
        slideMove: 3,
        mode: 'slide',
        useCSS: true,
        speed: 800,
        auto: false,
        loop: false,
        slideEndAnimation: false,
        keyPress: false,
        controls: false,
        prevHtml: '',
        nextHtml: '',
        rtl: false,
        adaptiveHeight: false,
        slideMargin: 60,
        pager: true,
        gallery: false,
        thumbMargin: 30,
        currentPagerPosition: 'left',
        enableTouch: false,
        enableDrag: true,
        freeMove: false,
        swipeThreshold: 1,
        responsive : [
        {
           breakpoint: 1200,
           settings: {
             slideMargin: 30,
             item: 2,
             slideMove: 2,
         },
       },
       {
          breakpoint: 1024,
          settings: {
              slideMargin: 30,
          },
        },
        {
          breakpoint: 768,
          settings: {
              slideMargin: 20,
              item: 2,
              slideMove: 2,
              enableTouch: true,
          },
        },
        {
          breakpoint: 630,
          settings: {
              slideMargin: 20,
              item: 1,
              slideMove: 1,
              enableTouch: true,
          },
        },
        {
          breakpoint: 567,
          settings: {
              slideMargin: 20,
              item: 1,
              slideMove: 1,
              enableTouch: true,
          },
        },
      ],

      onSliderLoad: function (el) {
        edit_slider_width(el);
      },
    });
    light_slider_controls(home_project_slider, '#home-section-three');
    }

    if ($('#home-mixed-slider').length) {
      var home_mixed_slider = $('#home-mixed-slider').lightSlider({
        item: 3,
        autoWidth: false,
        slideMove: 3,
        mode: 'slide',
        useCSS: true,
        speed: 800,
        auto: false,
        loop: false,
        slideEndAnimation: false,
        keyPress: false,
        controls: false,
        prevHtml: '',
        nextHtml: '',
        rtl: false,
        adaptiveHeight: true,
        slideMargin: 60,
        pager: true,
        gallery: false,
        thumbMargin: 30,
        currentPagerPosition: 'left',
        enableTouch: false,
        enableDrag: true,
        freeMove: false,
        swipeThreshold: 1,
        responsive : [
        {
           breakpoint: 1200,
           settings: {
               slideMargin: 30,
               item: 2,
               slideMove: 2,
           },
         },
         {
            breakpoint: 1024,
            settings: {
                slideMargin: 30,
            },
          },
          {
            breakpoint: 768,
            settings: {
                slideMargin: 20,
                item: 2,
                slideMove: 2,
                enableTouch: true,
            },
          },
          {
            breakpoint: 630,
            settings: {
                slideMargin: 20,
                item: 1,
                slideMove: 1,
                enableTouch: true,
            },
          },
          {
            breakpoint: 567,
            settings: {
                slideMargin: 20,
                item: 1,
                slideMove: 1,
                enableTouch: true,
            },
          },
        ],
        onSliderLoad: function (el) {
          edit_slider_width(el);
        },
    });
    light_slider_controls(home_mixed_slider, '#home-section-five');
    }

    if ($('#example-project-slider').length) {
      var example_slider_one = $('#example-project-slider').lightSlider({
          item: 3,
          autoWidth: false,
          slideMove: 3, // slidemove will be 1 if loop is true
          mode: 'slide',
          useCSS: true,
          speed: 800, //ms'
          auto: false,
          loop: false,
          slideEndAnimation: false,
          keyPress: false,
          controls: false,
          prevHtml: '',
          nextHtml: '',
          rtl: false,
          adaptiveHeight: false,
          slideMargin: 60,
          pager: true,
          gallery: false,
          thumbMargin: 30,
          currentPagerPosition: 'left',
          enableTouch: false,
          enableDrag: true,
          freeMove: false,
          swipeThreshold: 1,
          responsive : [
          {
             breakpoint: 1200,
             settings: {
                 slideMargin: 30,
                 item: 2,
                 slideMove: 2,
             },
           },
           {
              breakpoint: 1024,
              settings: {
                  slideMargin: 30,
              },
            },
            {
              breakpoint: 768,
              settings: {
                  slideMargin: 20,
                  item: 1,
                  slideMove: 1,
                  enableTouch: true,
              },
            },
            {
              breakpoint: 567,
              settings: {
                  slideMargin: 20,
                  item: 1,
                  slideMove: 1,
                  enableTouch: true,
              },
            },
          ],
          onBeforeSlide: function (el) {
            edit_slider_width(el);
          },
      });
      light_slider_controls(example_slider_one, '#example-four');
    }

    if ($('#example-project-slider-two').length) {
      var example_slider_two = $('#example-project-slider-two').lightSlider({
        item: 3,
        autoWidth: false,
        slideMove: 3, // slidemove will be 1 if loop is true
        mode: 'slide',
        useCSS: true,
        speed: 800, //ms'
        auto: false,
        loop: false,
        slideEndAnimation: false,
        keyPress: false,
        controls: false,
        prevHtml: '',
        nextHtml: '',
        rtl: false,
        adaptiveHeight: false,
        slideMargin: 60,
        pager: true,
        gallery: false,
        thumbMargin: 30,
        currentPagerPosition: 'left',
        enableTouch: false,
        enableDrag: true,
        freeMove: false,
        swipeThreshold: 1,
        responsive : [
        {
           breakpoint: 1200,
           settings: {
               slideMargin: 30,
               item: 2,
               slideMove: 2,
           },
         },
         {
            breakpoint: 1024,
            settings: {
                slideMargin: 30,
            },
          },
          {
            breakpoint: 768,
            settings: {
                slideMargin: 20,
                item: 1,
                slideMove: 1,
                enableTouch: true,
            },
          },
          {
            breakpoint: 567,
            settings: {
                slideMargin: 20,
                item: 1,
                slideMove: 1,
                enableTouch: true,
            },
          },
        ],
        onBeforeSlide: function (el) {
          edit_slider_width(el);
        },
    });
    light_slider_controls(example_slider_two, '#example-five');
    }

    if ($('.single-project-slider').length) {
      var single_project_slider = $('.single-project-slider').lightSlider({
        item: 1,
        autoWidth: false,
        slideMove: 1, // slidemove will be 1 if loop is true
        mode: 'slide',
        useCSS: true,
        speed: 800, //ms'
        auto: false,
        loop: true,
        slideEndAnimation: false,
        keyPress: false,
        controls: false,
        prevHtml: '',
        nextHtml: '',
        rtl: false,
        adaptiveHeight: false,
        slideMargin: 0,
        vertical: false,
        pager: false,
        gallery: false,
        thumbMargin: 30,
        currentPagerPosition: 'left',
        enableTouch: false,
        enableDrag: true,
        freeMove: false,
        swipeThreshold: 1,
        onSliderLoad: function (el) {
          edit_slider_width(el);
        },
    });

    let next = document.querySelector('.slider-wrapper.single .next');
    let prev = document.querySelector('.slider-wrapper.single .prev');

    if (next) {
      next.addEventListener('click', function(e) {
        e.preventDefault();
        single_project_slider.goToNextSlide();
      });
    }

    if (prev) {
      prev.addEventListener('click', function(e) {
        e.preventDefault();
        single_project_slider.goToPrevSlide();
      });
    }

    sliderPagerDataCount('.slider-wrapper.single');
    }

    if ($('#about-team-slider').length) {
      var about_slider_one = $('#about-team-slider').lightSlider({
        item: 3,
        autoWidth: false,
        slideMove: 3, // slidemove will be 1 if loop is true
        mode: 'slide',
        useCSS: true,
        speed: 800, //ms'
        auto: false,
        loop: false,
        slideEndAnimation: false,
        keyPress: false,
        controls: false,
        prevHtml: '',
        nextHtml: '',
        rtl: false,
        adaptiveHeight: false,
        slideMargin: 60,
        pager: true,
        gallery: false,
        thumbMargin: 30,
        currentPagerPosition: 'left',
        enableTouch: false,
        enableDrag: true,
        freeMove: false,
        swipeThreshold: 1,
        responsive : [
        {
           breakpoint: 1200,
           settings: {
               slideMargin: 30,
               item: 2,
               slideMove: 2,
           },
         },
         {
            breakpoint: 1024,
            settings: {
                slideMargin: 30,
            },
          },
          {
            breakpoint: 768,
            settings: {
                slideMargin: 20,
                item: 2,
                slideMove: 2,
                enableTouch: true,
            },
          },
          {
            breakpoint: 630,
            settings: {
                slideMargin: 20,
                item: 1,
                slideMove: 1,
                enableTouch: true,
            },
          },
          {
            breakpoint: 567,
            settings: {
                slideMargin: 20,
                item: 1,
                slideMove: 1,
                enableTouch: true,
            },
          },
        ],
        onSliderLoad: function (el) {
          edit_slider_width(el);
        },
    });
    light_slider_controls(about_slider_one, '#about-section-five');
    }

    if ($('#about-general-slider').length) {
        var about_slider_two = $('#about-general-slider').lightSlider({
          item: 1,
          autoWidth: false,
          slideMove: 1, // slidemove will be 1 if loop is true
          mode: 'slide',
          useCSS: true,
          speed: 800, //ms'
          auto: false,
          loop: false,
          slideEndAnimation: false,
          keyPress: false,
          controls: false,
          prevHtml: '',
          nextHtml: '',
          rtl: false,
          adaptiveHeight: false,
          slideMargin: 0,
          pager: true,
          gallery: false,
          thumbMargin: 30,
          currentPagerPosition: 'left',
          enableTouch: false,
          enableDrag: true,
          freeMove: false,
          swipeThreshold: 1,
          onSliderLoad: function (el) {
            edit_slider_width(el);
          },
        });
        light_slider_controls(about_slider_two, '#about-section-six');
    }
    });
  },
};
